module.exports = __webpack_public_path__ + "img/tripadvisor.88b6d348.svg";